import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaStar,
  FaRegStar,
  FaMapMarkerAlt,
  FaChevronRight,
} from 'react-icons/fa';
import AppHeader from '../../shared/components/app-header/AppHeader';
import { getStringFromLS } from '../../shared/helper-utils/localStorage';
import { APP_USER_AUTH } from '../../saas/AppStorageStaticNames';
import './TestimonialsPage.scss';

function TestimonialsPage() {
  const userAuth = getStringFromLS(APP_USER_AUTH);
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [activeCardId, setActiveCardId] = useState(1);

  const testimonials = [
    {
      id: 1,
      category: 'agents',
      name: 'Ritika Sharma',
      role: 'Founder - Skyline Holidays',
      initials: 'RS',
      colorClass: 'green',
      rating: 5,
      text: '“Margins are better and the dashboard tells me exactly where every booking stands. No more chasing confirmations.”',
      location: 'Delhi',
    },
    {
      id: 2,
      category: 'operators',
      name: 'Mohammed Faizan',
      role: 'Operations Head - Wanderloop Tours',
      initials: 'MF',
      colorClass: 'navy',
      rating: 5,
      text: '“Onboarding sub-agents used to take weeks. With Fastays&apos; panel, we had our whole network live in four days.”',
      location: 'Hyderabad',
    },
    {
      id: 3,
      category: 'agents',
      name: 'Ananya Iyer',
      role: 'Director - Coastal Trail Travels',
      initials: 'AI',
      colorClass: 'orange',
      rating: 4,
      text: '“Support is genuinely 24x7. I&apos;ve messaged at 2 a.m. before a client&apos;s flight and got a real answer in minutes.”',
      location: 'Kochi',
    },
    {
      id: 4,
      category: 'corporate',
      name: 'Suresh Patil',
      role: 'CEO - Horizon Corporate Travels',
      initials: 'SP',
      colorClass: 'coral',
      rating: 5,
      text: '“Centralised billing and GST-ready invoices changed how our accounts team works. Closing books isn&apos;t a monthly headache anymore.”',
      location: 'Pune',
    },
    {
      id: 5,
      category: 'operators',
      name: 'Karan Mehta',
      role: 'Partner - Trailblazer Vacations',
      initials: 'KM',
      colorClass: 'navy',
      rating: 5,
      text: '“Commission payouts land on time, every time. That reliability is rare in this industry, and it&apos;s why we&apos;ve stayed two years running.”',
      location: 'Jaipur',
    },
    {
      id: 6,
      category: 'agents',
      name: 'Priya Nair',
      role: 'Manager - Spice Route Travels',
      initials: 'PN',
      colorClass: 'green',
      rating: 5,
      text: '“The interface just makes sense. New staff are booking confidently within their first week — no separate training needed.”',
      location: 'Bengaluru',
    },
  ];

  const filterTabs = [
    { label: 'All Stories', value: 'all' },
    { label: 'Travel Agents', value: 'agents' },
    { label: 'Tour Operators', value: 'operators' },
    { label: 'Corporate Travel', value: 'corporate' },
  ];

  const filteredTestimonials = testimonials.filter(
    (item) => selectedFilter === 'all' || item.category === selectedFilter,
  );

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i += 1) {
      if (i <= rating) {
        stars.push(<FaStar key={i} />);
      } else {
        stars.push(<FaRegStar key={i} />);
      }
    }
    return stars;
  };

  return (
    <>
      {(userAuth === null || userAuth === undefined) && <AppHeader />}
      <div className="testimonials-page">
        {/* Hero Section */}
        <section className="testimonials-hero">
          <div className="hero-bg-shapes">
            <svg viewBox="0 0 1440 320" preserveAspectRatio="none">
              <path
                fill="none"
                stroke="rgba(255, 255, 255, 0.05)"
                strokeWidth="2"
                d="M0,96C120,101.3,240,112,360,117.3C480,123,600,123,720,106.7C840,91,960,59,1080,48C1200,37,1320,48,1380,53.3L1440,58.7"
              />
              <path
                fill="none"
                stroke="rgba(255, 255, 255, 0.03)"
                strokeWidth="1.5"
                d="M0,192C180,160,360,128,540,144C720,160,900,224,1080,213.3C1260,203,1380,117,1410,74.7L1440,32"
              />
            </svg>
          </div>
          <div className="hero-content">
            <span className="partner-tag">Partner Stories</span>
            <h1 className="hero-title">
              5,000+ Travel Businesses Fly With{' '}
              <span className="highlight">Fastays</span>
            </h1>
            <p className="hero-desc">
              Here&apos;s why. Real feedback from travel agents, tour operators
              and corporate travel desks who book faster, settle quicker, and
              grow their margins on our B2B platform.
            </p>
            {(userAuth === null || userAuth === undefined) && (
              <div className="hero-buttons">
                <Link to="/agent-registration" className="btn-become-partner">
                  Become a Partner <FaChevronRight size={10} />
                </Link>
                <Link to="/login" className="btn-sign-in">
                  Sign In
                </Link>
              </div>
            )}
          </div>
        </section>

        {/* Stats banner */}
        <section className="stats-banner-container">
          <div className="stats-banner">
            <div className="stat-item">
              <span className="stat-value">5,000+</span>
              <span className="stat-label">Agents Onboarded</span>
            </div>
            <div className="stat-item">
              <span className="stat-value">120+</span>
              <span className="stat-label">Cities Covered</span>
            </div>
            <div className="stat-item">
              <span className="stat-value">4.8/5</span>
              <span className="stat-label">Avg. Partner Rating</span>
            </div>
            <div className="stat-item">
              <span className="stat-value">24x7</span>
              <span className="stat-label">Support Desk</span>
            </div>
          </div>
        </section>

        {/* Testimonials Feed */}
        <section className="stories-section">
          <div className="section-header">
            <h2 className="section-title">Stories From the Field</h2>
            <div className="filter-tabs">
              {filterTabs.map((tab) => (
                <button
                  key={tab.value}
                  type="button"
                  className={`filter-tab ${
                    selectedFilter === tab.value ? 'active' : ''
                  }`}
                  onClick={() => setSelectedFilter(tab.value)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          <div className="stories-grid">
            {filteredTestimonials.map((item) => (
              <div
                key={item.id}
                className={`testimonial-card ${
                  activeCardId === item.id ? 'active-card' : ''
                }`}
                onClick={() => setActiveCardId(item.id)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    setActiveCardId(item.id);
                  }
                }}
              >
                <div className="card-header-profile">
                  <div className={`avatar-circle ${item.colorClass}`}>
                    {item.initials}
                  </div>
                  <div className="profile-details">
                    <h4 className="client-name">{item.name}</h4>
                    <span className="client-title">{item.role}</span>
                  </div>
                </div>
                <div className="card-stars">{renderStars(item.rating)}</div>
                <p className="card-quote">{item.text}</p>
                <div className="card-divider" />
                <div className="card-footer-details">
                  <span className="card-location">
                    <FaMapMarkerAlt /> {item.location}
                  </span>
                  <span className="card-verified-badge">Verified Partner</span>
                </div>
              </div>
            ))}
          </div>

          <div className="grid-actions">
            <a
              href="https://www.trustpilot.com/review/fastays.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-read-all"
            >
              Read All Reviews
            </a>
          </div>
        </section>

        {(userAuth === null || userAuth === undefined) && (
          <section className="testimonials-cta-box">
            <div className="cta-banner">
              <div className="cta-content">
                <h2 className="cta-title">Ready to Take Off With Fastays?</h2>
                <p className="cta-desc">
                  Join thousands of agents and operators already booking
                  smarter.
                </p>
                <div className="cta-buttons">
                  <Link
                    to="/agent-registration"
                    className="btn-become-partner-cta"
                  >
                    Become a Partner <FaChevronRight size={10} />
                  </Link>
                  <a
                    href="https://www.trustpilot.com/review/fastays.com"
                    className="btn-share-story"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Share Your Story
                  </a>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </>
  );
}

export default TestimonialsPage;
